import { render } from "./Copy.vue?vue&type=template&id=35c7bbc7&scoped=true"
import script from "./Copy.vue?vue&type=script&lang=js"
export * from "./Copy.vue?vue&type=script&lang=js"

import "./Copy.vue?vue&type=style&index=0&id=35c7bbc7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c7bbc7"],['__file',"webpack-assets/vue/components/Copy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35c7bbc7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35c7bbc7', __exports__)) {
    api.reload('35c7bbc7', __exports__)
  }
  
  module.hot.accept("./Copy.vue?vue&type=template&id=35c7bbc7&scoped=true", () => {
    api.rerender('35c7bbc7', render)
  })

}


export default __exports__